<template>
  <main class="home">
    <!-- Header -->
    <HeaderM3 :logoLinkRoute="RouteName.M3Welcome" />
    <SaleTimeOut />
    <OffersPreparation offer-step="4/4" />
  </main>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import OffersPreparation from "@/apps/merchant3/components/offers/v2/preparing/OffersPreparation.vue";
import { onMounted } from "vue";
import { RoutesPageSteps } from "@/apps/merchant3/router/RoutesPageSteps";
import useCartPersistState from "@/apps/merchant3/hooks/useCartPersistState";
import { useStore } from "vuex";
import SaleTimeOut from "@/apps/merchant3/shared-components/common/SaleTimeout.vue";
import HeaderM3 from "@/apps/merchant3/components/HeaderM3.vue";
import { RouteName } from "@/apps/merchant3/router/RouteName";

const { t } = useI18n();
const store = useStore();
document.title = "PayJoy - " + t("PREPARING_OFFERS_TITLE");

onMounted(async () => {
  await store.dispatch("carts/setStep", RoutesPageSteps.Offers);

  useCartPersistState(() => true);
});
</script>
